module.exports = __webpack_public_path__ + "img/edit-2.f256ba95.svg";